<script>
  export let text = "";
  export let showNew = true;
</script>

<div class="paxbot_wrapper">
  <div class="paxbot_heading">
    {#if showNew}
      <span class="bold">Coming soon! </span>
    {/if}
    <br>
    {text}
  </div>
  <div class="bottom">
    <div class="button">
      <slot />
    </div>
    <img src="/img/assistant/paxbot_portrait.png" alt="paxbot" />
  </div>
</div>

<style>
  .paxbot_wrapper {
    background: var(--brand-gradient-topdown);
    padding: 1rem;
    padding-bottom: 0;
    color: white;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: var(--l);
  }

  .bottom {
    display: flex;
    width: 100%;
    align-items: flex-end;
    justify-content: space-between;
  }

  .button {
    padding-bottom: 1rem;
  }

  img {
    max-width: 30%;
    width: 30%;
  }
</style>
